import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=d4c3b8f4&scoped=true&"
import script from "./CCheckbox.vue?vue&type=script&lang=js&"
export * from "./CCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c3b8f4",
  null
  
)

export default component.exports